<template>
  <div class="funcset">
    <div class="banner_wrapper">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item>{{$t('setting.crumbs.L1')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('setting.crumbs.L4')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="panel">
			<div class="panel-header panel-header__fix">
        <div class="panel-select-group">
          <span class="panel-header__desc">{{$t('setting.crumbs.L4')}}</span>
        </div>
      </div>

			<div class="panel-body">
				<el-table :data="tableData">
					<el-table-column prop="functionname" :label="$t('setting.table.functionName')" min-width="50"></el-table-column>
					<el-table-column prop="note" :label="$t('setting.table.note')" min-width="120"></el-table-column>
					<el-table-column :label="$t('setting.table.status')" min-width="30">
						<template slot-scope="scope">
							<el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949" @change="changeStatus($event)"></el-switch>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<el-dialog :title="title" :visible.sync="dialogVisible" :before-close="handleClose" :close-on-press-escape="true" :destroy-on-close="true" :center="true" custom-class="mydialog">
				<div style="margin-bottom: 20px;">{{ content }}</div>
				<div class="divider"></div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="cancel">{{$t('setting.dialog.d6')}}</el-button>
					<el-button type="primary" @click="confirm">{{$t('setting.dialog.d5')}}</el-button>
				</span>
			</el-dialog>
    </div>
  </div>
</template>

<script>
	import axios from 'axios'
	import config from 'config'

	export default {
		data () {
			return {
				value: true,
				title: '',
				content: '',
				dialogVisible: false,
				tableData: [{
					functionname: this.$t('setting.table.functionNameCont'),
					note: this.$t('setting.table.noteCont')
				}]
			}
    },
		created () {
      let refund = sessionStorage.getItem('refund')
      if (refund === "true") {
        this.value = true
      } else {
        this.value = false
      }
		},
		methods: {
			changeStatus (item) {
				this.dialogVisible = true
				if (item) {
					this.title = this.$t('setting.dialog.d4')
					this.content = this.$t('setting.dialog.d8')
				}else {
					this.title = this.$t('setting.dialog.d3')
					this.content = this.$t('setting.dialog.d7')
				}
			},
			handleClose() {
				this.dialogVisible = false
				this.value = !this.value
			},
			cancel () {
        this.dialogVisible = false
        this.value = !this.value
			},
			confirm () {
        let status = this.value
        if (status === true) {
          status = "1"
        }else {
          status = "0"
        }
				let params = {
					status: status,
					format: 'cors'
				}
				axios.post(`${config.host}/merchant/user/edit/refund`, params).then((res) => {
					let data = res.data
					if (data.respcd === config.code.OK) {
						this.dialogVisible = false
            this.value = data.data.status
            if (this.value) {
              this.value = true
            }else {
              this.value = false
            }
            sessionStorage.setItem('refund', this.value)
					} else {
						this.$message.error(data.resperr)
					}
				})
			},
		}
	}
</script>

<style lang="scss">
	.funcset {
		.panel {
			.panel-body {
				.el-table {
					.el-table__row {
						td {
							.cell {
								padding-top: 30px;
								padding-bottom: 30px;
								.el-switch__input:checked + .el-switch__core {
									border-color: #84d040;
									background-color: #84d040;
									.el-switch__button {
										transform: translate(11px, 2px);
										left: -8px;
									}
								}
								.el-switch__core {
									width: 50px !important;
								}
								.el-switch__label--left,.el-switch__label--right {
									span {
										display: none;
									}
								}
							}
						}
					}
				}
			}
			.el-dialog__wrapper {
				.el-dialog__header {
					padding-bottom: 15px;
				}
				.dialog-footer {
					.el-button--default {
						margin-right: 10px;
						border: 1px solid #FE9B20;
						color: #FE9B20;
						width: 80px;
					}
					.el-button--primary {
						background-color: #84d03f;
						border: 1px solid #84d03f;
						width: 80px;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// functionSetting.vue?fad75e06